import { databaseService } from "../../services/database.service";
import { throwOrRedirect } from "../../utils/throw-or-redirect";

export async function loadTemplate(
  templateId: string | number,
  redirectToOnError?: string
) {
  let id = typeof templateId === "string" ? Number(templateId) : templateId;

  if (Number.isNaN(id)) {
    throwOrRedirect(redirectToOnError, `templateId is wrong: ${templateId}`);
  }

  const template = await databaseService.getTemplate(id);

  if (!template) {
    throwOrRedirect(redirectToOnError, `template not found: ${id}`);
  }

  return template!;
}
